const comm = {
    rebless_clinic: "리블레스 클리닉",
    rebless_clinic_is: "리블레스 클리닉은"
};

export default comm;